// Check for query param of configuredId before page finishes loading
// If configuredId is present, fetch configurator data and return as console.log
// If configuredId is not present, do nothing
// If configuredId is present, but no data is returned, do nothing
// If configuredId is present, and data is returned, add configuredId to product line item properties
document.addEventListener('DOMContentLoaded', async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const configuredId = urlParams.get('configuredId')
  if (configuredId) {
    const product =
      // document.querySelector('body').style.display = 'none'
      await fetch(`https://api.knottytie.com/configurator/${configuredId}`)
        .then((response) => response.json())
        .then((data) => {
          let colors = data.colors.reduce((acc, curr, index) => {
            const colorParam = `color${index + 1}=${curr.hex.substring(1)}`
            return acc + (index ? '&' : '') + colorParam
          }, '?')

          // Replace title
          const productNameElement = document.querySelector('h1.product_name')
          const productType = (productNameElement.textContent =
            productNameElement.textContent.replace(
              window.productData.type,
              `(Customized) ${window.productData.type}`
            ))

          // Hide Customize button
          document.querySelector('.customize-button').textContent =
            'Revise Colors'
          const url =
            document.querySelector('.customize-button').href.split('?')[0] +
            colors
          document.querySelector('.customize-button').href = url

          // Replace colors
          const newColors = document.createElement('div')
          for (const color of data.colors.reverse()) {
            const colorElement = document.createElement('span')
            colorElement.innerText = `${color.colorName} (${color.hex}, ${color.colorSet})`
            newColors.appendChild(colorElement)
            newColors.appendChild(document.createElement('br'))
          }
          document
            .querySelector('.colors-section .colors')
            .replaceWith(newColors)

          // Show alt products
          document.querySelector('.shopify-section--alt-colors').style.display =
            'none'
          document.querySelector('.configure-more').style.display = 'block'

          for (const l of document.querySelectorAll('.configure-more a')) {
            l.href = `${l.getAttribute(
              'data-base-url'
            )}${window.productData.handle.replace(
              window.productData.handleizedType,
              l.getAttribute('data-type')
            )}${colors}`
          }

          // Replace slideshow with single zoomable image
          const slideshow = document.querySelector('.product-gallery')
          const image = document.createElement('img')
          image.src = data.primary_image
          image.setAttribute('data-zoom-src', data.primary_image)
          image.setAttribute('data-action', 'zoom')
          slideshow.replaceWith(image)

          // Add hidden line item properties

          const hiddenCustomizedInput = document.createElement('input')
          hiddenCustomizedInput.type = 'hidden'
          hiddenCustomizedInput.name = 'properties[_customized]'
          hiddenCustomizedInput.value = 'true'
          hiddenCustomizedInput.setAttribute('form', `product-form`)
          document
            .querySelector('.product_form')
            .appendChild(hiddenCustomizedInput)

          const hiddenPreviewImageInput = document.createElement('input')
          hiddenPreviewImageInput.type = 'hidden'
          hiddenPreviewImageInput.name = 'properties[_preview_image]'
          hiddenPreviewImageInput.value = data.primary_image
          hiddenPreviewImageInput.setAttribute('form', `product-form`)
          document
            .querySelector('.product_form')
            .appendChild(hiddenPreviewImageInput)

          const hiddenConfiguredIdInput = document.createElement('input')
          hiddenConfiguredIdInput.type = 'hidden'
          hiddenConfiguredIdInput.name = 'properties[_configured_id]'
          hiddenConfiguredIdInput.value = configuredId
          hiddenConfiguredIdInput.setAttribute('form', `product-form`)
          document
            .querySelector('.product_form')
            .appendChild(hiddenConfiguredIdInput)

          const hiddenProductTypeInput = document.createElement('input')
          hiddenProductTypeInput.type = 'hidden'
          hiddenProductTypeInput.name = 'properties[_product_type]'
          hiddenProductTypeInput.value = window.productData.type
          hiddenProductTypeInput.setAttribute('form', `product-form`)
          document
            .querySelector('.product_form')
            .appendChild(hiddenProductTypeInput)

          const hiddenConfiguredIdLinkInput = document.createElement('input')
          hiddenConfiguredIdLinkInput.type = 'hidden'
          hiddenConfiguredIdLinkInput.name = 'properties[_configured_link_id]'
          hiddenConfiguredIdLinkInput.value = `https://knottytie.com/products/${window.productData.handle}?configuredId=${configuredId}`
          hiddenConfiguredIdLinkInput.setAttribute('form', `product-form`)
          document
            .querySelector('.product_form')
            .appendChild(hiddenConfiguredIdLinkInput)

          // Loop through colors, add line item property of "color[index]" = "colorName (colorHex)"
          for (const [index, color] of data.colors.entries()) {
            const hiddenColorInput = document.createElement('input')
            hiddenColorInput.type = 'hidden'
            hiddenColorInput.name = `properties[Color ${index + 1}]`
            hiddenColorInput.value = `${color.colorName} (${color.hex}, ${color.colorSet})`
            hiddenColorInput.setAttribute('form', `product-form`)
            document
              .querySelector('.product_form')
              .appendChild(hiddenColorInput)
          }

          console.log(data)
        })
        .catch((error) => {
          console.error(error)
        })
  }
})
